// Task #319 — PWA app-icon badge (Badging API).
// The installed app's icon shows a numbered badge equal to the user's unread
// badge-eligible notifications (system/maintenance/policy kinds excluded —
// see BADGE_EXCLUDED_KINDS in shared/notifications.ts; the server computes
// the count). Degrades gracefully: browsers without the Badging API are
// simply left unbadged.

export function isAppBadgeSupported(): boolean {
  return typeof navigator !== "undefined" && "setAppBadge" in navigator;
}

export async function setAppBadge(count: number): Promise<void> {
  if (!isAppBadgeSupported()) return;
  try {
    if (count > 0) {
      await (navigator as any).setAppBadge(count);
    } else {
      await (navigator as any).clearAppBadge();
    }
  } catch {
    /* never let badge failures surface */
  }
}

export async function clearAppBadge(): Promise<void> {
  if (!isAppBadgeSupported()) return;
  try {
    await (navigator as any).clearAppBadge();
  } catch {
    /* ignore */
  }
}
